export default __webpack_public_path__ + "static/roman-kushytskyy-c3c33c365eed57751377acee5d65e4e9.png";